import {z} from 'zod';

export const ExportSchema = z.object({
  url: z.string(),
});
export type ExportDto = z.infer<typeof ExportSchema>;

export const ExportFormatSchema = z.enum(['csv', 'xlsx']);
export type ExportFormatDto = z.infer<typeof ExportFormatSchema>;
